/**
 * Created by 不动的推动者 on 2018/4/30.
 */
/*****
 * 获取数据get + 对应路由名称
 * 向后台传数据 store + 对应路由名称
 * 驼峰命名
 * *****/


import { fetch, fetchMsg } from "./fetch"; //引用fetch.js

//获取首页的焦点广告
export function getFocusAdList(query) {
  return fetch({
    url: '/gg/',
    method: 'post',
    data: {
      "operation": "advertisement_list",
      "table": "cy_advertisement",
      "request": query
    }
  });
}

//获取首页的产品分类
export function getProductCategoryList(query) {
  return fetch({
    url: '/product/',
    method: 'post',
    data: {
      "operation": "category_list",
      "table": "cy_product_category",
      "request": query
    }
  });
}

//获取首页的最新动态
export function getNewsList(query) {
  return fetch({
    url: '/news/',
    method: 'post',
    data: {
      "operation": "news_list",
      "table": "cy_news",
      "request": query
    }
  });
}


//获取新闻动态 - 企业动态
export function getQydtNewsList(query) {
  return fetch({
    url: '/news/',
    method: 'post',
    data: {
      "operation": "news_list",
      "table": "cy_news",
      "request": query
    }
  });
}
//获取新闻动态 - 行业新闻
export function getHyxwNewsList(query) {
  return fetch({
    url: '/news/',
    method: 'post',
    data: {
      "operation": "news_list",
      "table": "cy_news",
      "request": query
    }
  });
}

//获取新闻动态详情
export function getNews(query) {
  return fetch({
    url: '/news/',
    method: 'post',
    data: {
      "operation": "details",
      "table": "cy_news",
      "request": query
    }
  });
}


//保存在线留言
export function saveMessage(query) {
  return fetchMsg({
    url: '/msg/',
    method: 'post',
    data: {
      "operation": "addOrUpdate",
      "table": "cy_msg",
      "request": query
    }
  });
}


//获取产品列表
export function getProductList(query) {
  return fetch({
    url: '/product/',
    method: 'post',
    data: {
      "operation": "product_list",
      "table": "cy_product",
      "request": query
    }
  });
}


//搜索产品
export function searchProduct(query) {
  return fetch({
    url: '/product/',
    method: 'post',
    data: {
      "operation": "product_list",
      "table": "cy_product",
      "request": query
    }
  });
}
//搜索最新动态
export function searchNews(query) {
  return fetch({
    url: '/news/',
    method: 'post',
    data: {
      "operation": "news_list",
      "table": "cy_news",
      "request": query
    }
  });
}




// WEBPACK FOOTER //
// ./src/axios/api.js